import { Box, Button } from "@material-ui/core";
import { useState } from "react";
import "./BookScreenBanner.css";
import Assignment from "../../../interfaces/Assignment";
import FirebaseService from "../../../services/firebase/FirebaseService";
import useModal from "../../Modals/UseModal";
import StandardModal from "../../Modals/StandardModal";
import ModalSize from "../../Modals/ModalSize";
import { RootState } from "../../../state/configureStore";
import { connect } from "react-redux";

// Pass in assignment data
interface BookScreenBannerProps {
  assignment: Assignment;
}

// Store user display name from state
interface BookScreenBannerDataProps {
  userName: string;
}

// Banner for teachers to duplicate assignments
const BookScreenBannerTeacher = (props: BookScreenBannerProps & BookScreenBannerDataProps) => {
  const [def, setDef] = useState("");
  const [id, setId] = useState("");
  const [bookId, setBookId] = useState("");
  const { open, openModal, closeModal } = useModal(false);
  const [isCopying, setIsCopying] = useState(false);

  return (
    <div>
      <Box height="40px" className="topBanner">
        <div className="topLeftText" />
        <div className="rightLayoutText">
          <Button
            onClick={() => {
              setIsCopying(true);
              setDef("Copying...");
              openModal();
              FirebaseService.copyAssignment(props.assignment, props.userName).then(res => {
                // Display error message if failed
                setIsCopying(false);
                if (!res) {
                  setDef("Could not copy " + props.assignment.title);
                } else {
                  // Set book and assignment Id for redirect
                  const realRes = res as { bookId: string; id: string };
                  setDef("Finished copying " + props.assignment.title);
                  setId(realRes.id);
                  setBookId(realRes.bookId);
                }
              });
            }}
            style={{ color: "white", cursor: "pointer" }}
          >
            Add to Assignments +
          </Button>
        </div>
      </Box>
      <StandardModal
        onlyOneButton={false}
        onSubmit={() => {
          if (!isCopying) {
            if (id.length && bookId.length) window.location.href = `/Assignments/${id}`;
            else closeModal();
          }
        }}
        cancelClose={closeModal}
        size={ModalSize.medium}
        open={open}
        title="Copying assignment"
        closeButtonText="Close"
        submitButtonText="Go To Assignment"
      >
        {def}
      </StandardModal>
    </div>
  );
};

// Store user name for copying assignment
const mapStateToProps = (state: RootState): BookScreenBannerDataProps => {
  return {
    userName: state.currentUserState.currentUser?.displayName || "",
  };
};

export default connect(mapStateToProps)(BookScreenBannerTeacher);
